function accordionGroupCtrl(scope) {
  const vm = this;
  vm.toggleAccordion = function () {
    scope.toggleGroup();
  };
}

module.exports = function () {
    return {
        restrict: 'AE',
        scope: {},
        require: '^bwsAccordion',
        controller: ['$scope', accordionGroupCtrl],
        controllerAs: 'vm',
        link(scope, element, attrs, accordionCtrl) {
           scope.toggleGroup = function () {
             if (!element.find('[bws-accordion-body]').is(':visible')) {
               accordionCtrl.closeAll();
             }
             scope.vm.toggleBody();
           };
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/accordion/accordion-group.js
 **/